import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { HotkeysShortcutPipe } from "@ngneat/hotkeys";

/**
 * Shortcut component that displays formatted keyboard shortcuts with customizable styling.
 * Uses the HotkeysShortcutPipe to format hotkey combinations for display.
 */
@Component({
  selector: "app-shortcut",
  imports: [CommonModule, HotkeysShortcutPipe],
  templateUrl: "./shortcut.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortcutComponent {
  hotkey = input.required<string>();
  color = input<string>("text-muted");
}
